module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-261.7cd9779.woff2";